module.exports = __webpack_public_path__ + "img/组 1118@2x.21e64bbf.png";